var _this = this;
import * as tslib_1 from "tslib";
import getFolderData from 'owa-mail-actions/lib/getFolderData';
import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
import { getFolder } from '../services/getFolder';
import { getFolderTable, lazyUpdateFolderPermissionsInFolderStore, SHARED_FOLDERS_TREE_TYPE, } from 'owa-folders';
import { getMailboxInfoFromFolderId } from 'owa-mail-mailboxinfo/lib/getMailboxInfo';
import { orchestrator } from 'satcheljs';
import { trace } from 'owa-trace';
export default orchestrator(getFolderData, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var folderId, sourceFolder, isSharedFolder, requestOptions;
    return tslib_1.__generator(this, function (_a) {
        folderId = actionMessage.folderId;
        sourceFolder = getFolderTable().get(folderId);
        isSharedFolder = sourceFolder && sourceFolder.treeType === SHARED_FOLDERS_TREE_TYPE;
        requestOptions = getMailboxInfoFromFolderId(folderId).requestOptions;
        getFolder(folderId, isSharedFolder, requestOptions)
            .then(function (responseMessage) {
            var folder = responseMessage && responseMessage.Folders[0];
            // Folder could be null if it's been deleted on the server
            if (folder) {
                updateFolderCounts(folder.UnreadCount, folder.TotalCount, folderId, false /* isDeltaChange */);
                if (isSharedFolder) {
                    // Populate the folder permissions in folder table
                    lazyUpdateFolderPermissionsInFolderStore
                        .import()
                        .then(function (updateFolderPermissionsInFolderStore) {
                        updateFolderPermissionsInFolderStore(folderId, folder.PermissionSet.Permissions);
                    });
                }
            }
        })
            .catch(function (error) {
            // no-op if refresh folder count fails
            // hierarchy notificaiton remains the primary channel to update folder counts
            trace.warn("GetFolderDataOrchestrator: " + error);
        });
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=getFolderDataOrchestrator.js.map